/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';

export interface IOtherVitals {
  id?: string;
  respiratoryRate?: number | null;
  bodyTemp?: number | null;
  bodySurfaceArea?: number | null;
  painScore?: number | null;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  glucoUser?: IGlucoUser;
}

export const defaultValue: Readonly<IOtherVitals> = {
  active: false,
};
